import { TextInput, Text, Card, Group, Textarea, Stack } from '@mantine/core';

interface ContactPersonCardProps {
  title: string;
  formContext: any;
  disabled?: boolean;
}

export const ContactPersonCard: React.FC<ContactPersonCardProps> = props => {
  const form = props.formContext();

  return (
    <div>
      <Card shadow="sm" padding="md" radius="md" withBorder>
        <Text fw={700} size="large">
          {props.title}
        </Text>
        <Group justify="space-between" grow className="flex items-start">
          <TextInput
            variant="filled"
            className="flex-grow"
            label="Titul"
            data-testid="contact-card-title"
            {...form.getInputProps('contacts.0.title')}
            disabled={props.disabled}
          />
          <TextInput
            variant="filled"
            className="flex-grow"
            label="Jméno"
            data-testid="contact-card-firstName"
            {...form.getInputProps('contacts.0.firstName')}
            disabled={props.disabled}
          />
          <TextInput
            variant="filled"
            className="flex-grow"
            label="Příjmení"
            data-testid="contact-card-lastName"
            {...form.getInputProps('contacts.0.lastName')}
            disabled={props.disabled}
          />
        </Group>
        <Group justify="space-between" grow className="flex items-start">
          <TextInput
            variant="filled"
            className="flex-grow"
            label="Vztah k zájemci"
            data-testid="contact-card-relation"
            {...form.getInputProps('contacts.0.relation')}
            disabled={props.disabled}
          />
          <TextInput
            variant="filled"
            className="flex-grow"
            label="E-mail"
            data-testid="contact-card-email"
            {...form.getInputProps('contacts.0.email')}
            disabled={props.disabled}
          />
          <TextInput
            variant="filled"
            className="flex-grow"
            label="Telefon"
            data-testid="contact-card-phone"
            {...form.getInputProps('contacts.0.phone')}
            disabled={props.disabled}
          />
        </Group>
        <Stack className="mt-6">
          <Textarea
            variant="filled"
            label="Popis stavu zájemce"
            data-testid="contact-card-statusDesc"
            autosize
            minRows={2}
            maxRows={6}
            {...form.getInputProps('statusDesc')}
            disabled={props.disabled}
          />
          <Textarea
            variant="filled"
            label="Četnost a čas naší pomoci"
            data-testid="contact-card-prefTime"
            autosize
            minRows={2}
            maxRows={6}
            {...form.getInputProps('prefTime')}
            disabled={props.disabled}
          />
        </Stack>
      </Card>
    </div>
  );
};
